import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@app/services';
import { StoreKey } from '@app/shared';
import { BehaviorSubject, filter, finalize, from, Observable, switchMap, take, throwError, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class JWTResponseInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject = new BehaviorSubject<boolean>(false);

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          switch (err.status) {
            case 401:
              const refreshToken = localStorage.getItem(StoreKey.REFRESHTOKEN);
              if (!refreshToken) {
                this.authService.logout();
                return observableThrowError(() => new Error('REFRESH_TOKEN_MISSING'));
              }

              if (this.refreshTokenInProgress) {
                return this.refreshTokenSubject.pipe(
                  filter((res) => !!res),
                  take(1),
                  switchMap(() => {
                    return next.handle(this.cloneRequest(req));
                  }),
                  catchError((error) => {
                    this.authService.logout();
                    return throwError(() => new Error(error));
                  }),
                );
              } else {
                this.refreshTokenInProgress = true;
                this.refreshTokenSubject.next(null);
                return this.authService.refreshTokenOb().pipe(
                  switchMap(() => {
                    this.refreshTokenSubject.next(true);
                    return next.handle(this.cloneRequest(req));
                  }),
                  finalize(() => (this.refreshTokenInProgress = false)),
                );
              }
            case 403:
              if (err.error?.path.includes('refreshToken')) {
                this.authService.logout();
              }
          }
          console.error(err);
          return observableThrowError(() => err);
        } else {
          return observableThrowError(() => new Error(err));
        }
      }),
    );
  }

  private cloneRequest(request: HttpRequest<any>): HttpRequest<any> {
    const token = sessionStorage.getItem(StoreKey.TOKEN);
    return request.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }
}
